import React, { useCallback, useEffect } from 'react';
import { Avatar } from 'stream-chat-react';
import type { SuggestionUser, SuggestionCommand } from 'stream-chat-react';

type SuggestionListItemProps = {
  item: SuggestionUser | SuggestionCommand;
    onClickHandler?: (event: React.MouseEvent, item: SuggestionUser | SuggestionCommand) => void;
    onSelectHandler?: (item: SuggestionUser | SuggestionCommand) => void;
    selected?: boolean;
    className?: string;
    style?: React.CSSProperties;
    component?: React.ComponentType<any>;
    languageCode?: string; 
};

export const CustomAutocompleteSuggestionItem: React.FC<SuggestionListItemProps> = ({
  item,
  onClickHandler,
  onSelectHandler,
  selected,
  className = '',
  languageCode
}) => {

  const handleClick = useCallback((event: React.MouseEvent) => {
    if (onClickHandler) {
    onClickHandler(event, item);
    }
}, [item, onClickHandler]);

  const handleMouseEnter = useCallback(() => {
    if (onSelectHandler) {
      onSelectHandler(item);
    }
  }, [item, onSelectHandler]);

  const isEveryoneMention = item.id === "everyone";
  const isUser = 'id' in item && 'name' in item;


  return (
    <div
      className={`str-chat__suggestion-item ${selected ? 'selected' : ''} ${className}`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      role="button"
      tabIndex={0}
    >
      {isUser && (
        <>
          <Avatar
            image={item.image}
            name={item.name}
          />
          <div className="str-chat__suggestion-item-text">
            {item.name}
            {isEveryoneMention && 
                (<span className="str-chat__suggestion-item-description">{languageCode['Notify everyone in the channel']}</span>          
            )}
          </div>
        </>
      )}
    </div>
  );
};
